<div class="table-responsive gung-responsive w-100">
  <table class="table table-striped-mobile">
    <thead>
      <tr>
        <th></th>
        <th>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-header-text"></span>
          </div>
        </th>
        <th>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-header-text"></span>
          </div>
        </th>
        <th>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-header-text"></span>
          </div>
        </th>
        <th>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-header-text"></span>
          </div>
        </th>
        <th style="min-width: 200px"></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
        <td>
          <div class="table-image">
            <div class="placeholder-glow">
              <div class="placeholder skeleton-image"></div>
            </div>
          </div>
        </td>
        <td>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-id"></span>
          </div>
        </td>
        <td>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-name"></span>
          </div>
        </td>
        <td class="text-nowrap">
          <div class="placeholder-glow">
            <span class="placeholder skeleton-text"></span>
          </div>
        </td>
        <td>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-price"></span>
          </div>
        </td>
        <td class="buy-btn">
          <div class="placeholder-glow">
            <span class="placeholder skeleton-button"></span>
          </div>
        </td>
        <td>
          <div class="placeholder-glow">
            <span class="placeholder skeleton-icon"></span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
